import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  styleUrls: ['./calender.component.scss'],
})
export class CalenderComponent implements OnInit {
  selectdate: any;
  dateFormate = new Date();
  constructor(public popoverController: PopoverController,
    public addCall: AddCall,) {
    this.renderCalendar();
  }

  ngOnInit() { }

  renderCalendar() {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    this.dateFormate.setDate(1);

    const monthDays = document.querySelector(".days");
    const lastDay = new Date(
      this.dateFormate.getFullYear(),
      this.dateFormate.getMonth() + 1,
      0
    ).getDate();

    const prevLastDay = new Date(
      this.dateFormate.getFullYear(),
      this.dateFormate.getMonth(),
      0
    ).getDate();

    const firstDayIndex = this.dateFormate.getDay();

    const lastDayIndex = new Date(
      this.dateFormate.getFullYear(),
      this.dateFormate.getMonth() + 1,
      0
    ).getDay();

    const nextDays = 7 - lastDayIndex - 1;


    document.querySelector(".date .mth").innerHTML = months[this.dateFormate.getMonth()];
    let year = new Date();
    let getYear = year.getFullYear();
    document.querySelector(".date .year").innerHTML = String(getYear);

    let days = "";

    for (let x = firstDayIndex; x > 0; x--) {
      days += `<div class="prev-date">${prevLastDay - x + 1}</div>`;
    }

    for (let i = 1; i <= lastDay; i++) {
      if (
        i === new Date().getDate() &&
        this.dateFormate.getMonth() === new Date().getMonth()
      ) {
        days += `<div class="today">${i}</div>`;
      } else {
        days += `<div>${i}</div>`;
      }
    }

    for (let j = 1; j <= nextDays; j++) {
      days += `<div class="next-date">${j}</div>`;
      monthDays.innerHTML = days;
    }
  };
  prev() {
    this.dateFormate.setMonth(this.dateFormate.getMonth() - 1);
    this.renderCalendar();
  }

  next() {
    this.dateFormate.setMonth(this.dateFormate.getMonth() + 1);
    this.renderCalendar();
  }



  //Temp===


/*


  getBkgDateCale(fromDate, toDate) {
    this.storeDates = [];
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);


    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          year: " ",
          month: " ",
          date: " "
        });
      }
    }

    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDate();
    console.log("monthEnd=>", monthEnd);
    for (let i = 1; i <= monthEnd; i++) {
      this.storeDates.push({
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i
      });
    }
    console.log("storeDate=>", this.storeDates);
  }

  next() {
    let nextMonth = new Date(this.myFromDate.getFullYear(), this.myFromDate.getMonth() + 1, this.myFromDate.getDate());
    console.log("nextMonth", nextMonth);
    this.getBkgDateCale(new Date(nextMonth), new Date(this.myToDate));
  }
  prev() {

    this.getBkgDateCale(new Date(this.myFromDate), new Date(this.myToDate));
  }*/
}
